export default __webpack_public_path__ + "static/media/Sajdah.86650993.mp3";